import { Box, Drawer } from '@mui/material';
import { styled } from '@mui/material/styles';

import { MOBILE_CONTAINER_WIDTH, VAR_AREA_TOP } from '@mopla/constants';

export const FullscreenDrawer = styled(Drawer)(() => ({
	'& .MuiDrawer-paper': {
		width: '100%',
		maxWidth: MOBILE_CONTAINER_WIDTH,
		height: '100%',
		display: 'flex',
		flexDirection: 'column',
		left: 0,
		right: 0,
		margin: '0 auto',
	},
}));

export const HeaderWrapper = styled(Box, {
	shouldForwardProp: (prop) => prop !== 'withShadow',
})<{ withShadow?: boolean }>(({ theme, withShadow }) => ({
	padding: theme.spacing(`calc(${VAR_AREA_TOP} + 16px)`, 2, 2, 1),
	transition: 'box-shadow 0.2s ease',
	boxShadow: withShadow ? '0 3px 20px 0 rgba(0, 0, 0, 0.25)' : 'none',
	zIndex: 1,
}));

export const Content = styled(Box)({
	flex: 1,
	overflow: 'auto',
	'.platform-ios.keyboard-is-open &': {
		paddingBottom: 'var(--keyboard-height, 0px)',
	},
});
